import { Component, OnDestroy, OnInit } from '@angular/core';
import { HeaderScriptInjectorService } from '../../services/script-injector/header-script-injector.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    providers: [HeaderScriptInjectorService],
})
export class HeaderComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject<void>();

    constructor(
        private headerScriptInjectorService: HeaderScriptInjectorService,
    ) {}

    ngOnInit(): void {
        this.headerScriptInjectorService.injectScripts();
    }

    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }
}
